import React, { Fragment } from 'react'
import { Container } from 'reactstrap'
import { Dashboard } from '../Dashboard/Dashboard'
import SecondaryNav from '../SubNavigation'
import Layout from '../Layout'
import Modal from './Modal'
import { DUES_QUERY } from '../widgets/MembershipFinance/MembershipDues'
import { COACH_TOOLS_API } from '../../apolloClient'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import { LoadingComponent } from '@pga/pga-component-library'

const TerminatedWrapper = ({ me }) => {
  const { data, error, loading } = useQuery(DUES_QUERY, {
    fetchPolicy: 'cache-and-network',
    context: { api: COACH_TOOLS_API }
  })
  if (loading) return <LoadingComponent />

  return (
    <div style={{ height: '80vh' }}>
      <Layout>
        <>
          <SecondaryNav />
          <Container>
            <Modal me={me} duesCycle={get(data, 'duesCycle') } />
            <section>
              <Dashboard me={me} authReady />
            </section>
          </Container>
        </>
      </Layout>
    </div>
  )
}
export default TerminatedWrapper
